import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as data from '../data/servicio.data';

@Component({
  selector: 'app-single-servicio',
  templateUrl: './single-servicio.component.html',
  styles: [
  ]
})
export class SingleServicioComponent implements OnInit {

  servicio: any;
  servicios = data.lista;
  
  constructor(public activateRoute: ActivatedRoute) {

    activateRoute.params.subscribe(params => {
      // tslint:disable-next-line: no-string-literal
      if (params['id']) {
        const id = params['id'];
        this.servicio = data.lista.filter(s => s.id == id)[0];
        console.log(this.servicio);


      }
    });

  }

  ngOnInit(): void {
  }

  goTo(section: string) {


    window.location.href = section;

    // $(location).href(section);

  }

}
